import { z } from 'zod';

export interface TeamAdminViewDto {
  id: number;
  name: string;
  internalPhoneNumberId: string;
  createdAt?: number;
  users: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    isManager: boolean;
  }[];
}

export const CreateTeamSchema = z
  .object({
    name: z.string().nonempty('required'),
    internalPhoneNumberId: z.string(),
  })
  .strict();

export type CreateTeamRequest = z.infer<typeof CreateTeamSchema>;

export const UpdateTeamSchema = z
  .object({
    name: z.string().optional(),
    internalPhoneNumberId: z.string().optional(),
  })
  .strict();

export type UpdateTeamRequest = z.infer<typeof UpdateTeamSchema>;
